export function displayEKGProductName(data_name) {
  switch (data_name) {
    case 'triangle_six':
      return 'KM6L Six'
    case 'triangle_single':
      return 'KM6L Single'
    case 'kardia_mobile':
      return 'KardiaMobile'
    case 'kardia_band':
      return 'KardiaBand'
    case 'omron_complete':
      return 'Omron Complete'
    case 'unspecified':
      return 'Unspecified'
    default:
      return data_name
  }
}

export const LOCAL_STORAGE_KARDIA_SUPPORT = 'kardiasupport_'
export const LOCAL_STORAGE_SUPPORT_USER = `${LOCAL_STORAGE_KARDIA_SUPPORT}support_user`

export const setSupportUser = (user) =>
  localStorage.setItem(LOCAL_STORAGE_SUPPORT_USER, JSON.stringify(user))

export const getSupportUser = () => {
  let user = localStorage.getItem(LOCAL_STORAGE_SUPPORT_USER) || ''
  if (user !== '') {
    return JSON.parse(user)
  } else {
    return user
  }
}

export const clearSupportUser = () =>
  localStorage.removeItem(LOCAL_STORAGE_SUPPORT_USER)

// Validation functions

export const VALIDATION_RULES = {
  EMAIL: (value, message) => {
    const isEmailValid =
      !!value && /^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    if (!isEmailValid) return message || 'Entered email is not valid'
    return isEmailValid
  },
  NUMBER_MORE_THAN_ZERO: (value, message) => {
    if (!/[0-9]/.test(value)) return 'Only numerical values are allowed'
    return value && value > 0 ? true : message || 'Value should be more than 0'
  },
  REQUIRED: (value, message) => {
    const errorText = message || 'This field is required'
    return String(value).length > 0 ? true : errorText
  },
  ONLY_NUMBER: (value, message) => {
    if (!/\d/.test(value)) return message || 'Only numerical values are allowed'
  },
  MIN_CHAR_LENGTH: (value, message, len) => {
    if (String(value).length < len) return message || `The value should be ${len} chars`
  },
  TWO_CHAR_LENGTH: (value, message) => {
    if (String(value).length != 2) return message || `The value should be 2 chars`
  },
  DATE: (value, message) => {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if(!value.match(datePattern)) return "Invalid date Format" || message 
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js